import React from 'react';
import { cx } from 'linaria';
import { jcm } from 'utils';
import { Typography } from 'fronton-react';
import {
  comma,
  newCurrencyWrap,
  newPriceContainer,
  newPriceFractWrap,
  newPriceMainWrap,
  oldCurrencyWrap,
  oldPriceCrossed,
  oldPriceWrapper,
  primaryPriceView,
  secondPriceView,
  signaturePrimary,
  signatureSecondary,
  subtitleView,
  textPrimaryStyle,
} from './styles';
import { ProductBestPriceNameplate } from './product-best-price-nameplate';
import { getFormattedOldPrice, getFormattedPrice, getNumericFract } from './utils';
import { SubtitleView } from './subtitle-view';
import { ProductPriceViewProps } from './types';
import { ProductDiscountPercent } from './product-discount-percent';
import { CrossedPrice } from './crossed-price';

const DATA_QA_PRICE_VIEW = 'price-view';

export const ProductPriceView: React.FC<ProductPriceViewProps> = ({
  currency,
  fract,
  intPart,
  prevPrice,
  slot,
  unit,
  variant = 'primary-price',
  isBestPrice,
  className = '',
  seoMeta,
  discountPercent,
  ...htmlProps
}) => {
  const hasOldPrice = variant === 'old-new-price';

  if (hasOldPrice || isBestPrice) {
    return (
      <div data-qa="price-view" className={className}>
        {isBestPrice ? (
          <ProductBestPriceNameplate />
        ) : (
          <div className={oldPriceWrapper}>
            <ProductDiscountPercent percent={discountPercent} />
            <CrossedPrice price={prevPrice} currency={currency} />
          </div>
        )}

        <div className={isBestPrice ? cx(newPriceContainer, textPrimaryStyle) : newPriceContainer}>
          <span className={newPriceMainWrap}>
            {getFormattedPrice(intPart) + (getNumericFract(fract) ? ',' : '')}
          </span>
          {getNumericFract(fract) > 0 && <span className={newPriceFractWrap}>{fract}</span>}
          <span className={cx(newCurrencyWrap)}>{`${currency}${unit ? `/${unit}` : ''}`}</span>
        </div>

        {isBestPrice && hasOldPrice && (
          <div className={oldPriceCrossed}>
            <Typography variant="m" size="body_accent" color="text-primary">
              {getFormattedOldPrice(prevPrice)}
            </Typography>
            <Typography variant="s" size="body_accent" color="text-primary" className={oldCurrencyWrap}>
              {currency}
            </Typography>
          </div>
        )}
      </div>
    );
  }
  return (
    <div
      data-qa={DATA_QA_PRICE_VIEW}
      className={jcm({
        [className]: true,
        [primaryPriceView]: variant === 'primary-price',
        [secondPriceView]: variant === 'second-price',
        [subtitleView]: variant === 'subtitle',
      })}
      {...htmlProps}
    >
      {variant !== 'subtitle' && (
        <>
          {getFormattedPrice(intPart)}
          {getNumericFract(fract) > 0 && (
            <>
              <span className={comma}>,</span>
              {fract}
            </>
          )}

          <span
            className={jcm({
              [signaturePrimary]: variant === 'primary-price',
              [signatureSecondary]: variant === 'second-price',
            })}
          >
            {currency}
            {unit && (
              <>
                <span>/</span>
                {unit}
              </>
            )}
          </span>
        </>
      )}
      {variant === 'subtitle' && (
        <SubtitleView
          fract={fract}
          currency={currency}
          unit={unit}
          intPart={intPart}
          prevPrice={prevPrice}
        />
      )}
      {seoMeta}
    </div>
  );
};
